module.exports = __webpack_public_path__ + "static/media/Rudolph The Red Nosed Reindeer Lyrics.4c7b9feb.mp3";